import React from 'react';
import {Button, Input, message, Modal, Popconfirm, Space, Table} from "antd";
import {DeleteOutlined, EditOutlined, Loading3QuartersOutlined} from "@ant-design/icons";
import {useEffect, useState} from "reactn";
import {collection, deleteDoc, doc, getDocs, setDoc} from "firebase/firestore";
import firebaseDb from "../firebase";

function Settings() {
    let [data, setData] = useState([]);
    let [loading, setLoading] = useState(false)
    let [isModalVisible, setIsModalVisible] = useState(false);
    let [updateData, setUpdateData] = useState({});
    let [fullData, setFullData] = useState({});

    let getSettings = async () => {
        const settingsSetRef = collection(firebaseDb, 'settings');
        const settingsSetSnapshot = await getDocs(settingsSetRef);
        const settingsSetList = settingsSetSnapshot.docs.map((doc) => {
            return {
                id: doc.id,
                ...doc.data(),
            }
        });
        setLoading(false)
        setData(settingsSetList);
    }
    const updateSetting = async () => {
        let settingName = Object.keys(fullData)[1];
        const settingsSetRef = collection(firebaseDb, 'settings');
        await setDoc(doc(settingsSetRef, fullData.id), {[settingName]: {...updateData}});
        setIsModalVisible(false);
        message.success(`${settingName.toUpperCase()} güncelleme başarılı.`);
    }
    useEffect(() => {
        setLoading(true)
        getSettings();
    }, [])
    let deleteRow = async (item_id) => {
        await deleteDoc(doc(firebaseDb, "settings", item_id));
        let newData = data.filter(el => el.id !== item_id);
        setData(newData)
    }
    const showModal = () => {
        setIsModalVisible(true);
    };
    const handleCancel = () => {
        setIsModalVisible(false);
    };
    let columns = [
        {
            title: 'Ayar Adı',
            dataIndex: 'docname',
            key: 'docname',
            sortDirections: ['descend', 'ascend'],
            render: (text, record) => (
                <span style={{fontWeight: 500}}>{Object.keys(record)[1].toUpperCase()}</span>
            )
        },
        {
            title: '',
            key: 'action',
            fixed: 'right',
            align: 'right',
            className: 'editColumn',
            width: 150,
            render: (text, record) => (
                <Space size="small">
                    <Button onClick={() => {
                        showModal()
                        let rec = record[Object.keys(record)[1]]
                        setFullData(record)
                        delete rec.id
                        setUpdateData(rec)
                    }}>
                        <EditOutlined/>
                        Düzenle
                    </Button>
                    <Popconfirm
                        onConfirm={() => deleteRow(record.id)} title="Silmeyi Onaylıyor musunuz?"
                        okText="Onayla" cancelText="Vazgeç">
                        <Button className="button4" type="danger" icon={<DeleteOutlined/>}>
                            Sil
                        </Button>
                    </Popconfirm>
                </Space>
            ),
        },
    ];
    return (
        <>
            <div className="list-head">
                <div className="list-title">
                    <h1>{"Ayarlar"}</h1>
                </div>
            </div>

            <div className="table-wrap">
                <Table className="button4" dataSource={data} columns={columns}
                       pagination={false}
                       loading={{spinning: loading, indicator: <Loading3QuartersOutlined spin/>, size: "large"}}/>
            </div>
            <Modal title="Ayarlar" visible={isModalVisible} okText={"Güncelle"} onOk={updateSetting}
                   onCancel={handleCancel}>
                <div>
                    {updateData && Object.keys(updateData).map((key, index) =>
                        (
                            <div style={{marginTop: 10}} key={index}>
                                <span style={{fontWeight: '500'}}>{key.toUpperCase()}</span>
                                <Input onClick={(e) => e.target.value = ''}
                                       onChange={(e) => setUpdateData({...updateData, [key]: e.target.value})}
                                       defaultValue={updateData[key]}/>
                            </div>
                        )
                    )}
                </div>
            </Modal>
        </>
    );
}

export default Settings;